'use client';

import { useEffect } from 'react';
import CallAheadForm from '../../call-ahead/CallAheadForm';

export const dynamic = 'force-dynamic';

export default function FranklinCallAhead() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('restaurantLocation', 'Mimosa Franklin');
      document.cookie = 'restaurantLocation=Mimosa Franklin; path=/; max-age=31536000';

      if (!(window as any).__locationFetchPatched) {
        const originalFetch = window.fetch.bind(window);
        window.fetch = (input: RequestInfo | URL, init: RequestInit = {}) => {
          const newInit: RequestInit = {
            ...init,
            headers: {
              ...(init.headers as any || {}),
              'X-Restaurant-Location': 'Mimosa Franklin',
            },
          };
          return originalFetch(input, newInit);
        };
        (window as any).__locationFetchPatched = true;
      }
    }
  }, []);

  return <CallAheadForm />;
} 